import React, { useState, useEffect } from 'react';
import Categories from '../components/Categories';
import Recommended from '../components/Recommended';
import { MdChevronLeft, MdChevronRight } from 'react-icons/md';
import './Home.css';

const Home = () => {
    const [currentSlide, setCurrentSlide] = useState(0);
    
    const banners = [
        '/Banner1d.png',
        // '/Banner1.png'
    ];

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % banners.length);
        }, 5000); // Auto-slide every 5 seconds

        return () => clearInterval(timer);
    }, [banners.length]);

    const goToSlide = (index) => {
        setCurrentSlide(index);
    };

    const goToPrevious = () => {
        setCurrentSlide((prev) => (prev - 1 + banners.length) % banners.length);
    };

    const goToNext = () => {
        setCurrentSlide((prev) => (prev + 1) % banners.length);
    };

    return (
        <div className="home-page">
            {/* Banner Carousel */}
            <div className="banner-carousel">
                <div className="carousel-container">
                    {banners.map((banner, index) => (
                        <div
                            key={index}
                            className={`carousel-slide ${index === currentSlide ? 'active' : ''}`}
                            style={{ transform: `translateX(-${currentSlide * 100}%)` }}
                        >
                            <img src={banner} alt={`Banner ${index + 1}`} />
                        </div>
                    ))}
                </div>

                {/* Navigation Arrows */}
                <button className="carousel-arrow left" onClick={goToPrevious}>
                    <MdChevronLeft size={30} />
                </button>
                <button className="carousel-arrow right" onClick={goToNext}>
                    <MdChevronRight size={30} />
                </button>

                {/* Dots Indicator */}
                <div className="carousel-dots">
                    {banners.map((_, index) => (
                        <button
                            key={index}
                            className={`dot ${index === currentSlide ? 'active' : ''}`}
                            onClick={() => goToSlide(index)}
                        />
                    ))}
                </div>
            </div>
            
            <Categories />
            <Recommended />
        </div>
    );
};

export default Home;
